export const trackGenderSelect = (e) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'gender_select',
      'eventCategory': 'questions_answers',
      'eventAction': 'gender_select',
      'eventLabel': e.target.value,
    });
  };